const Menu = [
  {
    title: 'Dashboard',
    group: 'General',
    icon: 'mdi-home',
    name: 'home'
  },
  {
    title: 'Applikasi',
    group: 'apps',
    icon: 'mobile_friendly',
    name: 'applist'
  },
  {
    title: 'Menu Applikasi',
    group: 'apps',
    icon: 'fa fa-tasks',
    name: 'appmenu'
  },
  {
    title: 'Kategori',
    group: 'apps',
    icon: 'mdi-tag-multiple',
    name: 'kategori'
  },
  {
    title: 'Slider Banner',
    group: 'apps',
    icon: 'collections',
    name: 'slider'
  },
  {
    title: 'Berita',
    group: 'apps',
    icon: 'fa fa-newspaper-o',
    name: 'news'
  },
  {
    title: 'POPUP',
    group: 'apps',
    icon: 'chrome_reader_mode',
    name: 'popup'
  },
  {
    title: 'Running Text',
    group: 'apps',
    icon: 'event_note',
    name: 'runningtext'
  },
  {
    title: 'Token SMS',
    group: 'apps',
    icon: 'mdi-email',
    name: 'tokensms',
  },
  {
    title: 'Topup Channel',
    group: 'apps',
    icon: 'account_balance_wallet',
    name: 'topupchannel',
  },
  {
    title: 'Wallet',
    group: 'apps',
    badge: true,
    icon: 'account_balance_wallet',
    name: 'wallet',
  },
    /*
  {
    title: 'Modal Kerja',
    group: 'apps',
    badge: true,
    icon: 'account_balance_wallet',
    name: 'modalkerja',
  },
  */
  {
    title: 'Oper Deposit',
    group: 'apps',
    badge: true,
    icon: 'account_balance_wallet',
    name: 'modalkerjav2',
  },
  {
    title: 'Delete Account',
    group: 'apps',
    icon: 'fa-eraser',
    name: 'deleteakun'
  },
  {
    title: 'Digipos',
    group: 'apps',
    icon: 'fa fa-star',
    name: 'digipos'
  },
  {
    title: 'Isimple',
    group: 'apps',
    icon: 'fa fa-star-half-o',
    name: 'isimple'
  },
  {
    title: 'Sidompul',
    group: 'apps',
    icon: 'fa fa-star-o',
    name: 'sidompul'
  }
]
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      const textA = x.title.toUpperCase()
      const textB = y.title.toUpperCase()
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
  }
})

export default Menu
